import { deleteData, getData, postData, patchData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { AxiosRequestConfig } from "axios";
import { ResponseDto } from "src/dtos/common/responseDto";

import { KSK1080_R01Dto } from "./Dto_KSK1080_R01";
import { KSK1080_R01Filter } from "./Store_KSK1080_R01";

const baseUrl = `${config.apiUrl}/KSK1080_R01/search`;

// 통합 재고 조회 API (view 파라미터로 탭별 데이터 분기)
export const getKSK1080_R01Data = async (view: string, params: Partial<KSK1080_R01Filter>) => {
	const url = `${baseUrl}`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		itemGroup: params.itemGroup || undefined,
		brandCd: params.brandCd || undefined,
		view,
		option: 'search', // LIMIT 제한 해제를 위한 옵션 추가
	};

	return await getData<ResponseDto<KSK1080_R01Dto[]>>(url, { params: requestParams });
};

// 통합 Excel 내보내기 API
export const exportKSK1080_R01Excel = async (view: string, params: Partial<KSK1080_R01Filter>) => {
	const url = `${baseUrl}/excel`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		itemGroup: params.itemGroup || undefined,
		brandCd: params.brandCd || undefined,
	};


	// view는 쿼리 파라미터로, 나머지는 body로 전송
	return await postData<Partial<KSK1080_R01Filter>, ResponseDto<string>>(url, requestParams, { params: { view } });
};

// 하위 호환을 위한 기존 함수들 (deprecated)
export const getKSK1080_R01List = async (searchType: string, params: Partial<KSK1080_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${searchType}`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		itemGroup: params.itemGroup || undefined,
		brandCd: params.brandCd || undefined,
		listLength,
		view: 'ALL'
	};

	return await getData<ResponseDto<KSK1080_R01Dto[]>>(url, { params: requestParams });
};
